exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  padding:2ex;\n  margin:2ex;\n  border: thin solid silver\n}\n\ndiv.main.isCurrentSearch {\n  border-color: red;\n  border-width: thick;\n}\n\nspan.done {\n  font-size: small;\n  font-style: italic;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/batch-search-box/batch-search-box.component.css
// module id = 380
// module chunks = 0